import React from 'react';

const MyButton = ({ btntext, onClick, backgroundColor = "var(--primary-gradient-100)", color = "#FFF", border = "0", fontSize = "24px", fontWeight = "500" }) => {

    const buttonStyle = {
        background: backgroundColor,
        color: color,
        transition: "color 0.3s ease",
        borderRadius: "20px",
        fontSize: fontSize,
        fontWeight: fontWeight,
        border: border
    };
    return (
        <>
            <button className={`my-button d-flex align-items-center gap-2 py-2 px-4`} style={buttonStyle} onClick={onClick}>
                <span>{btntext}</span>
            </button>
            <style>
                {`
                .my-button:hover {
                    background: var(--primary-gradient-100);
                    color: #FFF;
                }
                `}
            </style>
        </>
    )
}

const OutlineButton = ({ btnbackground = "#fff", onClick }) => {
    return (
        <div style={{ background: "var(--primary-gradient-100)", padding: "2px", borderRadius: "20px", width: "fit-content" }} >
            <button className={`my-button d-flex align-items-center gap-2 py-2 px-4  border-0`} style={{ borderRadius: "18px", backgroundColor: btnbackground }} onClick={onClick}>
                <span>Read More</span>
            </button>
        </div>
    );
}

export { MyButton, OutlineButton };